const ServiceProduit = {

	getProduit: function(prestationKey, produitKey) {
		let produit;

		try {
			produit = require(process.env.REACT_APP_PATH_DATA + '/produit-' + prestationKey + '-' + produitKey + '.json');
		} catch (error) {
			console.error(error);
		}
		return produit;
	}

}
export default ServiceProduit;